define('src/service',[
    // Libs
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/i18n',
], function(
    _, Backbone, moment, U,
    // services
    i18n
) {

    var Service = function(options) {
        this.lang = i18n.language;
        this.lastFetch = null;
        this.initialize.apply(this, arguments);
    };

    _.extend(Service.prototype, Backbone.Events, {
        fetchDelay: 8, // default delay in hour
        initialize: _.noop,
        onSync: _.noop,
        onError: _.noop,

        /**
         * False if the promise is pending, or the last fetch was within the delay.
         * Force a new fetch if the lang has changed since the last fetch.
         * @return {Boolean} fetch is needed
         */
        isFetchDue: function() {
            var lastFetch = this.lastFetch,
                promise = this.promise,
                isPending = promise && promise.state() === "pending";

            return !isPending && !lastFetch || // not fetched yet?
                (moment().diff(lastFetch, 'hours') > this.fetchDelay || // is delay passed?
                    this.lang !== i18n.language); // has lang changed?
        },

        fetch: function(options) {
            options = options || {};
            if (this.isFetchDue() || options.force) {
                this.promise = this.model.fetch({
                    context: this,
                    success: this._onSync,
                    error: this._onError
                });
            }
            return this.promise;
        },

        _onSync: function() {
            this.lang = i18n.language;
            this.lastFetch = moment();
            this.onSync.apply(this, arguments);
            this.trigger('sync', this);
        },
        _onError: function() {
            this.lastFetch = null;
            this.onError.apply(this, arguments);
        },

    });

    Service.extend = Backbone.Router.extend;

    return Service;

});

